import { render, staticRenderFns } from "./AddEditItemDialog.vue?vue&type=template&id=9adc47e6&scoped=true&"
import script from "./AddEditItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditItemDialog.vue?vue&type=style&index=0&id=9adc47e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adc47e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9adc47e6')) {
      api.createRecord('9adc47e6', component.options)
    } else {
      api.reload('9adc47e6', component.options)
    }
    module.hot.accept("./AddEditItemDialog.vue?vue&type=template&id=9adc47e6&scoped=true&", function () {
      api.rerender('9adc47e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/activity-log/AddEditItemDialog.vue"
export default component.exports